import { render, staticRenderFns } from "./ViewProfileContainer.vue?vue&type=template&id=30baec46&scoped=true"
import script from "./ViewProfileContainer.vue?vue&type=script&lang=js"
export * from "./ViewProfileContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30baec46",
  null
  
)

export default component.exports